import { render, staticRenderFns } from "./SettingsAdmin.vue?vue&type=template&id=502103e2&scoped=true"
import script from "./SettingsAdmin.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsAdmin.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SettingsAdmin.vue?vue&type=style&index=0&id=502103e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502103e2",
  null
  
)

export default component.exports